import styled from "styled-components";

// that is a temporary one, as withLoginCheck is going to be deleted
export const StyledSpinnerWrapper = styled.div`
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
`;
